import { useNavigate } from "react-router-dom";

export default function PaymentCancelled() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="bg-white rounded-xl shadow-md p-6 max-w-sm text-center">
        <h1 className="text-xl font-semibold text-red-600 mb-2">
          Payment Cancelled
        </h1>
        <p className="text-sm text-slate-600 mb-4">
          Your payment was not completed. No booking has been created.
        </p>

        <button
          onClick={() => navigate(-1)}
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg"
        >
          Try again
        </button>
      </div>
    </div>
  );
}
